import { render, staticRenderFns } from "./AiZhilan.vue?vue&type=template&id=30c2cc39&"
import script from "./AiZhilan.vue?vue&type=script&lang=js&"
export * from "./AiZhilan.vue?vue&type=script&lang=js&"
import style0 from "./AiZhilan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports